import { useState } from "react";

const offices = [
  { icon: "🇬🇧", region: "Europe",       city: "UK - Reading",               address: "61A Bath Road, Reading, RG30 2BB",                                                                                           phone: "+44 7818 951496",  type: "Regional HQ", lat: 51.4543,  lng: -0.9781   },
  { icon: "🇺🇸", region: "Americas",     city: "USA - San Bernardino, CA",    address: "473 E Carnegie Dr #200, San Bernardino, CA 92408",                                                                          phone: "+1 720-263-9280",  type: "Global HQ",  lat: 34.0522,  lng: -117.2923 },
  { icon: "🇦🇺", region: "Asia Pacific", city: "Australia - Adelaide",        address: "8 Beulah Road, Norwood SA 5067",                                                                                            phone: "+1 (358) 232-6135",                     lat: -34.9285, lng: 138.6007  },
  { icon: "🇲🇾", region: "Asia Pacific", city: "Malaysia - Kuala Lumpur",     address: "Level 28, The Gardens South Tower, Mid Valley City, 59200 KL",                                                             phone: "+603-2298-7135",                        lat: 3.1478,   lng: 101.6953  },
  { icon: "🇸🇬", region: "Asia Pacific", city: "Singapore",                   address: "12 Marina Blvd, 17-01 Tower 3, Marina Bay Financial Centre, 018982",                                                       phone: "+65 6549 7044",                         lat: 1.2789,   lng: 103.8536  },
  { icon: "🇵🇭", region: "Asia Pacific", city: "Philippines - San Juan City", address: "Unit 301, 164 L. Gruet St, Brgy Maytunas, San Juan City 1500",                                                            phone: "",                                      lat: 14.6042,  lng: 121.0338  },
  { icon: "🇮🇳", region: "South Asia",   city: "India - Hyderabad",           address: "R R Towers 4th Floor, Plot 188 & 189, Phase 2, Kavuri Hills, Madhapur, Telangana 500033",                                 phone: "",                                      lat: 17.4449,  lng: 78.3498   },
  { icon: "🇮🇳", region: "South Asia",   city: "India - Delhi",               address: "206, 2nd Floor Allied House Building No.1, LSC Near Pushpa Bhawan, Saket, New Delhi 110062",                              phone: "",                                      lat: 28.5272,  lng: 77.2159   },
  { icon: "🇮🇳", region: "South Asia",   city: "India - Bhubaneswar",         address: "GA 13, Sailashree Vihar, Khordha, Odisha - 751021",                                                                       phone: "",                                      lat: 20.3420,  lng: 85.8193   },
];

const services = [
  "Geospatial Services", "Managed Services", "Software Development",
  "COTS Implementation", "rUNr® Migration Platform", "ConduitPro®",
  "Fueerza", "SLD Platform", "Energize & Deenergize", "Consulting & Advisory",
];

const demos = [
  { icon: "🚀", name: "rUNr®",                  desc: "Automate complex GIS migrations with 99.99% accuracy." },
  { icon: "🔌", name: "ConduitPro®",             desc: "Conduit hierarchy management and association intelligence." },
  { icon: "📱", name: "Fueerza",                 desc: "Field force management, GPS tracking and mobile workflows." },
  { icon: "⚡", name: "SLD Platform",            desc: "GIS-integrated electrical schematic creation & management." },
  { icon: "🔄", name: "Energize & Deenergize",   desc: "Real-time outage management and crew dispatch." },
  { icon: "☁️", name: "Managed Services",        desc: "Cloud, DevOps, and E2E managed service model overview." },
];

const quickContacts = [
  { icon: "✉️", label: "Email",    value: "info@inovaantage.com",             href: "mailto:info@inovaantage.com" },
  { icon: "🌐", label: "Website",  value: "www.inovaantage.com",              href: "https://www.inovaantage.com" },
  { icon: "💼", label: "LinkedIn", value: "linkedin.com/company/inovaantage", href: "https://linkedin.com/company/inovaantage" },
];

/* ── MAIN COMPONENT ─────────────────────────────────────────── */
export default function ContactUs() {
  const [form, setForm]               = useState({ name: "", company: "", service: "", message: "" });
  const [submitted, setSubmitted]     = useState(false);
  const [selectedOffice, setSelectedOffice] = useState(null);

  const handleChange  = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  const handleSubmit  = () => { if (form.name && form.company) setSubmitted(true); };

  const selected = selectedOffice !== null ? offices[selectedOffice] : null;
  const mapSrc   = selected
    ? `https://www.openstreetmap.org/export/embed.html?bbox=${selected.lng - 0.04},${selected.lat - 0.025},${selected.lng + 0.04},${selected.lat + 0.025}&layer=mapnik&marker=${selected.lat},${selected.lng}`
    : `https://www.openstreetmap.org/export/embed.html?bbox=-20,10,145,65&layer=mapnik`;

  const scrollToForm = () => {
    const el = document.querySelector(".cp-form-card");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      {/* ── HERO ─────────────────────────────────────────────── */}
      <div className="cp-hero">
        <div className="cp-hero-orb1" />
        <div className="cp-hero-orb2" />
        <div className="cp-hero-inner">
          <div className="cp-tag">Contact Us</div>
          <h1 className="cp-hero-title">
            Let's <span className="accent">Talk</span>
          </h1>
          <p className="cp-hero-sub">
            Ready to accelerate your digital transformation? Reach out to our team
            for a consultation, product demo, or partnership inquiry.
          </p>
        </div>
      </div>

      {/* ── FORM + OFFICES ───────────────────────────────────── */}
      <section className="cp-section cp-section--dark">
        <div className="cp-inner">
          <div className="cp-layout">

            {/* ── CONTACT FORM ── */}
            <div className="cp-form-card">
              {submitted ? (
                <div className="cp-success">
                  <div className="cp-success-ring">✅</div>
                  <h3>Message Sent!</h3>
                  <p>Thank you for reaching out. Our team will respond within 1 business day.</p>
                  <button className="cp-btn-outline" onClick={() => setSubmitted(false)}>
                    Send Another Message
                  </button>
                </div>
              ) : (
                <>
                  <p className="cp-form-title">Contact Us</p>
                  <p className="cp-form-sub">Fill in your details and we'll get back to you within 24 hours.</p>

                  <div className="cp-field">
                    <label>Name <span>*</span></label>
                    <input
                      className="cp-input"
                      name="name"
                      placeholder="Your full name"
                      value={form.name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="cp-field">
                    <label>Company <span>*</span></label>
                    <input
                      className="cp-input"
                      name="company"
                      placeholder="Your organisation"
                      value={form.company}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="cp-field">
                    <label>Service of Interest</label>
                    <select
                      className="cp-select"
                      name="service"
                      value={form.service}
                      onChange={handleChange}
                    >
                      <option value="">Select a service…</option>
                      {services.map((s, i) => (
                        <option key={i} value={s}>{s}</option>
                      ))}
                    </select>
                  </div>

                  <div className="cp-field">
                    <label>Message</label>
                    <textarea
                      className="cp-textarea"
                      name="message"
                      rows={4}
                      placeholder="Tell us about your project or requirements…"
                      value={form.message}
                      onChange={handleChange}
                    />
                  </div>

                  <button className="cp-submit-btn" onClick={handleSubmit}>
                    Send Message →
                  </button>

                  <p className="cp-form-footer">
                    Or email us directly:{" "}
                    <a href="mailto:info@inovaantage.com" className="cp-form-footer-link">
                      info@inovaantage.com
                    </a>
                  </p>
                </>
              )}
            </div>

            {/* ── GLOBAL OFFICES (dropdown + map) ── */}
            <div>
              <p className="cp-offices-title">Global Offices</p>
              <p className="cp-offices-sub">
                Select a location to zoom to it on the map.
              </p>

              {/* Dropdown selector */}
              <div className="cp-office-dropdown-wrap">
                <select
                  className="cp-office-select"
                  value={selectedOffice ?? ""}
                  onChange={e => setSelectedOffice(e.target.value === "" ? null : Number(e.target.value))}
                >
                  <option value="">— Select an office location —</option>
                  {offices.map((o, i) => (
                    <option key={i} value={i}>
                      {o.icon} {o.city}{o.type ? ` (${o.type})` : ""}
                    </option>
                  ))}
                </select>
              </div>

              {/* Map iframe */}
              <div className="cp-map-wrap">
                <iframe
                  key={String(selectedOffice)}
                  src={mapSrc}
                  title="Office Location Map"
                  className="cp-map-iframe"
                  frameBorder="0"
                  scrolling="no"
                  allowFullScreen
                />

                {selected ? (
                  <div className="cp-map-info">
                    <span className="cp-map-flag">{selected.icon}</span>
                    <div>
                      <p className="cp-map-city">{selected.city}</p>
                      <p className="cp-map-addr">{selected.address}</p>
                      {selected.phone && <p className="cp-map-phone">📞 {selected.phone}</p>}
                      {selected.type && <span className="cp-map-badge">{selected.type}</span>}
                    </div>
                  </div>
                ) : (
                  <div className="cp-map-hint">
                    <span>🌍</span>
                    <p>Select an office above to zoom to its location</p>
                  </div>
                )}
              </div>

              {/* Quick Contact */}
              <div className="cp-qc-section">
                <p className="cp-qc-title">Quick Contact</p>
                <div className="cp-qc-row">
                  {quickContacts.map((c, i) => (
                    <a
                      key={i}
                      href={c.href}
                      className="cp-qc-card"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="cp-qc-icon">{c.icon}</div>
                      <div>
                        <p className="cp-qc-label">{c.label}</p>
                        <p className="cp-qc-value">{c.value}</p>
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── DEMO SECTION ─────────────────────────────────────── */}
      <section className="cp-demo-section">
        <div className="cp-inner">
          <div className="cp-demo-header">
            <div className="cp-tag">Product Demos</div>
            <h2>See Our Products <span>in Action</span></h2>
            <p>
              Request a live demonstration of any of our platform solutions —
              tailored to your industry.
            </p>
          </div>

          <div className="cp-demo-grid">
            {demos.map((d, i) => (
              <div key={i} className="cp-demo-card">
                <div className="cp-demo-icon">{d.icon}</div>
                <p className="cp-demo-name">{d.name}</p>
                <p className="cp-demo-desc">{d.desc}</p>
                <button className="cp-demo-btn" onClick={scrollToForm}>
                  Request Demo
                </button>
              </div>
            ))}
          </div>

          <p className="cp-demo-note">
            All demos are{" "}
            <strong>tailored to your specific industry and use case</strong>{" "}
            — no generic presentations.
          </p>
        </div>
      </section>
    </>
  );
}
